var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{attrs:{"id":"ding-login"}}),_vm._v(" "),_c('el-button',{on:{"click":_vm.dingLogin}},[_vm._v("钉钉登录")]),_vm._v(" "),_c('el-button',{on:{"click":_vm.dingLogin}},[_vm._v("微信登录")]),_vm._v(" "),_c('el-button',{on:{"click":_vm.dingLogin}},[_vm._v("QQ 登录")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-02d72612","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/views/pageview/Login.vue
// module id = null
// module chunks = 